import {emitOnClick, emitOnBlur, emitOnChange, emitOnKeyPress} from '@cred/react-analytics/hoc'
import withFieldChangeEvent from '@cred/react-analytics/hoc/withFieldChangeEvent'
import withLinkClickEvent from '@cred/react-analytics/hoc/withLinkClickEvent'
import navigateOnClick from '@cred/shared/hoc/navigateOnClick'
import emitGAOnClick from '@cred/shared/hoc/emitGAOnClick'
import {Link} from '@cred/react-link'
import Input from '../input'
import Dropdown from '../dropdown'
import Radio from '../radio'
import MoneyInput from '../money-input'
import AddressSearch from '../address-search'
import {textInput, zipInput, select, hiddenInput} from '@cred/react-form-field'
import selectCustom from '@cred/react-form-field/select-custom'

const linkWithAnalytics = /*#__PURE__*/ navigateOnClick(withLinkClickEvent(emitOnClick(emitGAOnClick(Link)))),
  textInputWithAnalytics = /*#__PURE__*/ withFieldChangeEvent(emitOnBlur(emitOnKeyPress(textInput))),
  zipInputWithAnalytics = /*#__PURE__*/ withFieldChangeEvent(emitOnBlur(emitOnKeyPress(zipInput))),
  radioWithAnalytics = /*#__PURE__*/ withFieldChangeEvent(Radio),
  selectCustomWithAnalytics = /*#__PURE__*/ emitOnChange(selectCustom),
  selectWithAnalytics = /*#__PURE__*/ emitOnChange(select),
  dropdownWithAnalytics = /*#__PURE__*/ withFieldChangeEvent(Dropdown),
  addressSearchWithAnalytics = /*#__PURE__*/ withFieldChangeEvent(AddressSearch),
  moneyInputWithAnalytics = /*#__PURE__*/ withFieldChangeEvent(MoneyInput)

export {
  textInputWithAnalytics,
  zipInputWithAnalytics,
  selectWithAnalytics,
  selectCustomWithAnalytics,
  dropdownWithAnalytics as Dropdown,
  radioWithAnalytics as Radio,
  linkWithAnalytics as Link,
  Input,
  addressSearchWithAnalytics as AddressSearch,
  moneyInputWithAnalytics as MoneyInput,
  hiddenInput
}
